import { render, staticRenderFns } from "./PazienteMain.vue?vue&type=template&id=72ae3a95"
import script from "./PazienteMain.vue?vue&type=script&lang=js"
export * from "./PazienteMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports